/**
 * BookingWizard — definizione step per tipo evento.
 *
 * eventType:
 *  - 'rental'     : noleggio/locazione barca (POST /api/bookings)
 *  - 'experience' : escursione/esperienza   (POST /api/excursion-bookings)
 *
 * Gli step sono adattati dal tipo e (per rental) dal rentalMode (range vs hourly).
 * Le shell renderizzano gli step in base a questa config; l'engine valida per-step.
 */

export type BookingEventType = 'rental' | 'experience';
export type BookingRentalMode = 'daily' | 'weekly' | 'monthly' | 'hourly';

export interface WizardStepDef {
  key: string;
  /** chiave i18n (namespace bookingWizard.step.*) + fallback. */
  labelKey: string;
  labelFallback: string;
}

const STEP = (key: string, labelFallback: string): WizardStepDef => ({
  key,
  labelKey: `bookingWizard.step.${key}`,
  labelFallback,
});

/** Step per il noleggio. Per orario lo step date diventa "orario+durata". */
export function rentalSteps(mode: BookingRentalMode): WizardStepDef[] {
  return [
    mode === 'hourly' ? STEP('datetimeHourly', 'Data & orario') : STEP('dates', 'Date & orari'),
    STEP('guests', 'Ospiti'),
    STEP('extras', 'Extra & servizi'),
    STEP('review', 'Riepilogo'),
    STEP('payment', 'Pagamento'),
  ];
}

/** Step per l'esperienza/escursione. */
export function experienceSteps(): WizardStepDef[] {
  return [
    STEP('slot', 'Data & partenza'),
    STEP('people', 'Persone'),
    STEP('extras', 'Extra'),
    STEP('review', 'Riepilogo'),
    STEP('payment', 'Pagamento'),
  ];
}

export function stepsFor(eventType: BookingEventType, rentalMode: BookingRentalMode = 'daily'): WizardStepDef[] {
  return eventType === 'rental' ? rentalSteps(rentalMode) : experienceSteps();
}
